import React, { Component } from 'react';
import {
  IonSegment,
  IonContent,
  IonSegmentButton,
  IonLabel,
  IonIcon,
} from '@ionic/react';
import './index.css';
import { isDefined } from '../../lib/utils';
import { withTranslation } from '../../lib/translate';
import Slider, { Slide } from '../slider';

class SwipableTabs extends Component {
  constructor(props) {
    super(props);
    const { defaultTab } = this.props;
    this.state = {
      selectedTab: defaultTab || 0,
      swiper: null
    };
  }

  componentDidMount() {
    if (
      this.props.history &&
      this.props.history.state &&
      this.props.history.state.tab === 'order'
    ) {
      this.segmentChanged(1);
    }
  }

  componentDidUpdate(prevProps,prevState) {
    if (this.props.history && prevProps.history.state !== this.props.history.state) {
      // fix: redirect to the scan tab if user is located in 'loyalty' page but on the first tab
      // and that he clicks on scan icon in header
      if (this.props.history.state?.tab === 'scan') {
        this.segmentChanged(1);
      } else if (
        this.props.history &&
        this.props.history.state &&
        this.props.history.state.tab === 'points'
      ) {
        this.segmentChanged(0);
      }
    }
    if((prevState.swiper !== this.state.swiper) && this.props?.history?.state?.tab === 'order'){
      this.segmentChanged(1);
    }
  }

  segmentChanged = (value) => {
    const { swiper } = this.state; 
    this.setState({ selectedTab: value });
    if (swiper) {
      swiper.slideTo(value);
    }
  };

  // On Segment change slide to the matching slide
  onSegmentChange = (ev) => {
    this.slideTo(ev.detail.value);
  };

  slideTo = (index) => {
    this.slides.slideTo(index);
  };

  // On Slide change update segment to the matching value
  onSlideDidChange = async () => {
    const index = await this.slides.getActiveIndex();
    this.clickSegment(index);
  };

  clickSegment = (index) => {
    this.segment.value = index;
  };

  render() {
    const { selectedTab } = this.state;
    const { available_balance, __ } = this.props;
    const tabs = this.props.tabs || [];

    return (
      <div className="tabs">
        <div className="segment-holder">
          <IonSegment
            onIonChange={(e) => this.segmentChanged(e.detail.value)}
            value={selectedTab}
            mode="md"
          >
            {tabs.map((tab, index) => {
              const { label, icon } = tab;
              return (
                <IonSegmentButton key={index + '_segment'} value={index}>
                  {isDefined(icon) ? <IonIcon name={icon}></IonIcon> : null}
                  <IonLabel>{label || ''}</IonLabel>
                </IonSegmentButton>
              );
            })}
          </IonSegment>
        </div>
        <Slider
        onSlideChange={(index) => this.segmentChanged(index)}
          settings={{
            loop: false,
            initialSlide: selectedTab,
            onSwiper: (swiper) => this.setState({swiper: swiper})

          }
          }>
          {tabs.map((tab, index) => {
            return (
              <Slide key={index + 'slide'} className={'slide-' + (index + 1)}>
                <IonContent>{tab.tabContent || null}</IonContent>
              </Slide>
            );
          })}
        </Slider>
      </div>
    );
  }
}

export default withTranslation(SwipableTabs);
